import type { ComponentContentSchema } from '@vibesites/runtime';

/**
 * Price Brothers override: the special-offer banner and floating pill are not
 * used on these sites at this time, so this slot renders nothing. The slot is
 * still declared on every page in the inherited pages.json; overriding it here
 * hides the banner and pill site-wide without having to replay each page's
 * section list. Restore the parent theme's implementation to re-enable it.
 */
export function SpecialOfferBanner() {
  return null;
}

export const contentSchema: ComponentContentSchema = {
  slot: 'SpecialOfferBanner',
  displayName: 'Special Offer Banner',
  tokens: {},
  slotGroups: {},
  collectionBindings: {
    'specialofferbanner.items': {
      label: 'Special Offers',
      collection: 'special_offers',
    },
  },
};

(SpecialOfferBanner as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default SpecialOfferBanner;
